import createStore from "view-ui-admin/src/utils/create-store";
import Model from "@/models/admin/forms";

export default createStore({ Model });
